/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './PartiuGpPremio.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

const SIMULAR_URL =
  'https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=partiu-gp-da-inglaterra:premio&int_campaign=simular-financiamento';

const itens = [
  {
    imagem: 'assets/partiu-gp-da-inglaterra/premio/ingressos.png',
    alt: 'Equipe de pit stop trabalhando no carro da Santander, vista de cima.',
    texto: 'Ingressos para treino livre, classificatória e Grande Prêmio da Inglaterra',
  },
  {
    imagem: 'assets/partiu-gp-da-inglaterra/premio/experiencias.png',
    alt: 'Pit stop da Santander em ação na pista.',
    texto: 'Experiências exclusivas',
  },
  {
    imagem: 'assets/partiu-gp-da-inglaterra/premio/tour.png',
    alt: 'Torcedores acompanhando o carro passar junto à grade.',
    texto: 'Tour em Londres com hospedagem e experiências gastronômicas',
  },
  {
    imagem: 'assets/partiu-gp-da-inglaterra/premio/acompanhante.png',
    alt: 'Torcida acenando nas arquibancadas.',
    texto: 'Para você e seu acompanhante',
  },
];

function PartiuGpPremio() {
  return (
    <section id="partiu-gp-premio">
      <ContainerHome24>
        <p className="eyebrow">Prêmio</p>
        <h2 className="titulo">Uma viagem para o Grand Prix na Inglaterra</h2>

        <div className="itens">
          {itens.map((item) => (
            <div className="item" key={item.texto}>
              <img src={item.imagem} alt={item.alt} className="item-img" />
              <p className="item-texto">{item.texto}</p>
            </div>
          ))}
        </div>

        <a href={SIMULAR_URL} target="_blank" rel="noopener" className="cta">
          Simular agora
        </a>

        <p className="disclaimer">
          *Programação sujeita a alterações. Consulte o regulamento para conhecer todos os itens
          incluídos na premiação, condições de participação e demais regras da promoção.
        </p>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpPremio;
